import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import exp from "constants";
import { CallItem, PacketItem } from "reducers/callsReducer";
import { ExtractedDumpsItem } from "reducers/extractedDumpsReducer";
import { LoginRequest, LoginResponse } from "reducers/loginReducer";
import { RawPacketItem, RawPacketGroupItem } from "reducers/rawPacketsReducer";
import { FileItem } from "reducers/filesReducer";


const isLocalhost = window.location.hostname === "localhost";
const apiUrl = isLocalhost
    ? "https://dumps.lexico-telecom.com/apiweb"
    : new URL("/apiweb", window.location.origin).href;

export const apiSlice = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({
        baseUrl: apiUrl,
        prepareHeaders: (headers: any) => {
            headers.set("Accept", "application/json");

            const token = localStorage.getItem("token");
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            return headers;
        }
    }),
    endpoints: (builder) => ({
        getCalls: builder.query<CallItem[], { time_from: string; time_to: string; number_from: string; number_to: string; ip_src: string; ip_dst: string; method_code: string }>({
            query: (params) => {
                return {
                    url: "calls",
                    method: "POST",
                    params
                };
            }
        }),

        orderDump: builder.mutation<{ success: boolean }, { call_id: string }>({
            query: (params) => {
                return {
                    url: "dump/create",
                    method: "POST",
                    params
                };
            }
        }),
        downloadDump: builder.mutation<Blob, { dump_filename: string }>({
            query: ({ dump_filename }) => ({
                url: `dump/${dump_filename}`,
                method: "GET",
                responseHandler: res => res.blob()
            })
        }),
        getPackets: builder.query<PacketItem[], { call_id: string }>({
            query: (params) => {
                return {
                    url: "packets",
                    method: "POST",
                    params
                };
            }
        }),
        getExtractedDumps: builder.query<ExtractedDumpsItem[], { time_from: string; time_to: string; number_from: string; number_to: string; ip_src: string; ip_dst: string }>({
            query: (params) => {
                return {
                    url: "dumps",
                    method: "POST",
                    params
                };
            }
        }),
        getRawPackets: builder.query<RawPacketItem[], { time_from: string; time_to: string; ip_src: string; ip_dst: string; call_id: string; method_code: string }>({
            query: (params) => {
                return {
                    url: "packets_filter",
                    method: "POST",
                    params
                };
            }
        }),
        getFiles: builder.query<FileItem[], { time_from: string; time_to: string; source: string }>({
            query: (params) => {
                return {
                    url: "files",
                    method: "POST",
                    params
                };
            }
        }),
        downloadFile: builder.mutation<Blob, { key: number }>({
            query: ({ key }) => ({
                url: `file/${key}`,
                method: "GET",
                responseHandler: res => res.blob()
            })
        }),
        login: builder.mutation<LoginResponse, LoginRequest>({
            query: (credentials) => ({
                url: "login",
                method: "POST",
                body: credentials
            })
        })
    })
});

export const {
    useGetCallsQuery,
    useOrderDumpMutation,
    useDownloadDumpMutation,
    useGetPacketsQuery,
    useGetExtractedDumpsQuery,
    useGetRawPacketsQuery,
    useGetFilesQuery,
    useDownloadFileMutation,
    useLoginMutation
} = apiSlice;